// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";

function getWrappedChildren(children, onMouseOver, onMouseOut, onClick) {
  return React.createElement("div", {
              onClick: Belt_Option.getWithDefault(onClick, (function (param) {
                      
                    })),
              onMouseOut: Belt_Option.getWithDefault(onMouseOut, (function (param) {
                      
                    })),
              onMouseOver: Belt_Option.getWithDefault(onMouseOver, (function (param) {
                      
                    }))
            }, children);
}

function getPixelPositionOffset(width, height) {
  return {
          x: -(width / 2 | 0) | 0,
          y: -height | 0
        };
}

function make_props(position, mapPaneNameOpt, onMouseOverOpt, onMouseOutOpt, onClickOpt, children, ref, param) {
  var mapPaneName = mapPaneNameOpt !== undefined ? Caml_option.valFromOption(mapPaneNameOpt) : "overlayMouseTarget";
  var onMouseOver = onMouseOverOpt !== undefined ? Caml_option.valFromOption(onMouseOverOpt) : undefined;
  var onMouseOut = onMouseOutOpt !== undefined ? Caml_option.valFromOption(onMouseOutOpt) : undefined;
  var onClick = onClickOpt !== undefined ? Caml_option.valFromOption(onClickOpt) : undefined;
  return {
          position: position,
          mapPaneName: mapPaneName,
          children: children,
          wrappedChildren: getWrappedChildren(children, onMouseOver, onMouseOut, onClick),
          getPixelPositionOffset: getPixelPositionOffset,
          ref: ref
        };
}

export {
  getWrappedChildren ,
  getPixelPositionOffset ,
  make_props ,
  
}
/* react Not a pure module */
